import { render, staticRenderFns } from "./NearCompany.vue?vue&type=template&id=00c18402"
import script from "./NearCompany.vue?vue&type=script&lang=js"
export * from "./NearCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports